module.exports = __webpack_public_path__ + "static/img/cabin4.cfffb23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/cabin4.jpg
// module id = 6fRZ
// module chunks = 4